export const BrowserNames = {
  Safari: 'Safari',
  Opera: 'Opera',
  MSIE: 'Microsoft Internet Explorer',
  Chrome: 'Chrome',
  Firefox: 'Firefox'
}
